module.exports = __webpack_public_path__ + "static/media/Pin-Dark-Viatura.1552fd9c.svg";